import { Component } from '@angular/core';
import { AbstractModalWithResult } from 'src/app/shared/components/abstract-modal-with-result';

@Component({
  selector: 'app-confirm-anonymize',
  templateUrl: './confirm-anonymize.component.html',
  styleUrls: ['./confirm-anonymize.component.scss'],
})
export class ConfirmAnonymizeComponent extends AbstractModalWithResult<void> {
  static modalId = 'ConfirmAnonymizeComponent';

  getModalId() {
    return ConfirmAnonymizeComponent.modalId;
  }
}
